import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { Col, Row, Button, Form, InputGroup } from "react-bootstrap";
import MyNavbar from "../component/navbar";
import MyNavbarInner from "../component/navbarinner";
import MyFooter from "../component/footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import logo from "../assets/images/logo_large.svg";
import { toastAlert } from "../helper/toastAlert";
import { numberOnly } from "../helper/custommath";
import "react-phone-input-2/lib/style.css";
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInput from "react-phone-input-2";
import {
  regValidate,
  regInputValidate,
  otpInputValidate,
  otpValidate,
} from "../validation/validation";
import {
  register,
  verifyEmail,
  resendOTP,
  verifyPhoneNo,
  resendPhoneOTP,
} from "../ApiAction/api";
import isEmpty from "is-empty";
import { Roller } from "react-awesome-spinners";

let initialValue = {
  name: "",
  email: "",
  phoneNo: "",
  referralId: "",
  password: "",
  dial_code: "+91",
  confirmpassword: "",
  terms: false,
  joinmethod: "phone",
};

let initialData = {
  otp: "",
};

export default function JoinUs() {
  const [userData, setUserData] = useState(initialValue);
  const [error, setError] = useState({});
  const [isLoad, setisLoad] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [otpData, setOtpData] = useState(initialData);
  const [verifystatus, setVerifyStatus] = useState(false);
  const [expireTime, setExpireTime] = useState(0);
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [firebaseError, setFirebaseError] = useState("");

  let {
    name,
    email,
    phoneNo,
    terms,
    dial_code,
    password,
    confirmpassword,
    referralId,
    joinmethod,
  } = userData;
  let { otp } = otpData;

  let { Id } = useParams();
  let navigate = useNavigate();

  let handleChange = (e) => {
    let { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;
    const resetData = { ...userData, [name]: fieldValue };
    delete error[name];
    setUserData(resetData);
    let errMsg = regInputValidate(resetData, name);
    setError({ ...error, ...errMsg });
  };

  const handlePhoneNumber = (value, country) => {
    const { dialCode } = country;
    let phoneNo = value;
    let formData = userData;

    if (!isValidPhoneNumber("+" + value) && value.length > 3) {
      setError({ ...error, ...{ phoneNo: "Invalid phone Number" } });
    } else {
      setError({ ...error, ...{ phoneNo: "" } });
    }
    if (isEmpty(value)) {
      setError({ ...error, ...{ phoneNo: "" } });
    }
    if (dialCode) {
      formData = {
        ...formData,
        ...{
          dial_code: dialCode,
          phoneNo: phoneNo.slice(dialCode.length),
        },
      };
    } else if (value) {
      formData = { ...formData, ...{ phoneNo } };
    }
    setUserData(formData);
  };

  let handleClick = async () => {
    try {
      if (Id) {
        userData.referralId = Id;
      }
      let errMsg = await regValidate(userData);
      console.log(errMsg, "errMsgerrMsg");
      setError(errMsg);
      if (isEmpty(errMsg)) {
        setisLoad(true);
        let { status, message, errors } = await register(userData);
        if (status == true) {
          setisLoad(false);
          toastAlert("success", message, "register");
          setVerifyStatus(true);
          setExpireTime(180);
          getTime();
        } else if (!isEmpty(errors)) {
          setisLoad(false);
          setError(errors);
          setUserData(initialValue);
          return;
        } else {
          setisLoad(false);
          toastAlert("error", message, "register");
          setUserData(initialValue);
        }
      }
    } catch (err) {
      console.log(err, "errr");
    }
  };

  let handleOtpChange = (e) => {
    let { name, value } = e.target;
    var resetData = { ...otpData, ...{ [name]: value } };
    delete error[name];
    setOtpData(resetData);
    let errMsg = otpInputValidate(resetData, name);
    setError({ ...error, ...errMsg });
  };

  let handleOtpClick = async () => {
    try {
      let errMsg = await otpValidate(otpData);
      setError(errMsg);
      console.log(isEmpty(errMsg), errMsg, "daaaaaattttttt");
      if (isEmpty(errMsg)) {
        if (expireTime == 0) {
          toastAlert("error", "OTP expired,Please resend", "otp");
          setOtpData({});
        } else {
          setisLoad(true);
          let data = { otp, email };
          let { message, status } = await verifyEmail(data);
          if (status == true) {
            toastAlert("success", message, "otp");
            // setTimeout(() => {
            //     window.location.href = "/login";
            // }, 100);
            navigate("/login");
            setisLoad(false);
          } else {
            toastAlert("error", message, "otp");
            setisLoad(false);
          }
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  let resendCode = async () => {
    try {
      let data = {
        email,
      };
      let { message, status } = await resendOTP(data);
      if (status == true) {
        toastAlert("success", message, "otp");
        setExpireTime(180);
        getTime();
        setisLoad(false);
      } else {
        toastAlert("error", message, "otp");
        setisLoad(false);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  let resendPhoneCode = async () => {
    try {
      let data = {
        dial_code,
        phoneNo,
      };
      let { message, status } = await resendPhoneOTP(data);
      if (status == true) {
        toastAlert("success", message, "otp");
        setExpireTime(180);
        getTime();
        setisLoad(false);
      } else {
        toastAlert("error", message, "otp");
        setisLoad(false);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  let handlePhoneOtpClick = async () => {
    try {
      let errMsg = await otpValidate(otpData);
      setError(errMsg);
      console.log(isEmpty(errMsg), errMsg, "daaaaaattttttt");
      if (isEmpty(errMsg)) {
        if (expireTime == 0) {
          toastAlert("error", "OTP expired,Please resend", "otp");
          setOtpData({});
        } else {
          setisLoad(true);
          let data = {
            otp,
            dial_code: userData.dial_code,
            phoneNo: userData.phoneNo,
          };
          let { message, status } = await verifyPhoneNo(data);
          if (status == true) {
            toastAlert("success", message, "otp");
            // setTimeout(() => {
            //     window.location.href = "/login";
            // }, 100);
            navigate("/login");
            setisLoad(false);
          } else {
            toastAlert("error", message, "otp");
            setisLoad(false);
          }
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  let getTime = async () => {
    if (expireTime > 0) {
      setTimeout(() => {
        console.log("timeeeeeee");
        if (expireTime != 0) {
          setExpireTime(expireTime - 1);
        }
      }, 1000);
    }
  };

  useEffect(() => {
    if (expireTime > 0) {
      getTime();
    }
  }, [expireTime]);

  console.log(userData, "userData");
  return (
    <>
      <MyNavbar />
      {!verifystatus ? (
        <section>
          <Container>
            <div className="join_sec">
              <Row>
                <Col xl="5">
                  <div className="reg_form">
                    <p className="join_head">Join Now</p>
                    <Form.Group className="mb-3 d-flex align-items-center gap-3">
                      <Form.Label
                        className="input_join mb-0"
                        htmlFor="inputPassword5"
                      >
                        Join With
                      </Form.Label>
                      {/* <Form.Group className="d-flex align-items-center gap-2">
                        <Form.Check
                          type="radio"
                          id="radio_1"
                          name="joinmethod"
                          value="email"
                          checked={joinmethod === "email"}
                          onChange={handleChange}
                        />
                        <Form.Label htmlFor="radio_1" className="mb-0">
                          Email
                        </Form.Label>
                      </Form.Group> */}

                      <Form.Group className="d-flex align-items-center gap-2">
                        <Form.Check
                          type="radio"
                          id="radio_2"
                          name="joinmethod"
                          value="phone"
                          checked={joinmethod === "phone"}
                          onChange={handleChange}
                        />
                        <Form.Label htmlFor="radio_2" className="mb-0">
                          Phone Number
                        </Form.Label>
                      </Form.Group>
                    </Form.Group>
                    {joinmethod === "email" && (
                      <Form.Group className="mb-4">
                        <Form.Label
                          className="input_join"
                          htmlFor="inputPassword5"
                        >
                          Email
                        </Form.Label>
                        <Form.Control
                          className="input_text"
                          type="text"
                          id="inputPassword5"
                          placeholder="Enter your email"
                          aria-describedby="passwordHelpBlock"
                          name="email"
                          onChange={handleChange}
                          value={email}
                        />
                        {error && error.email && (
                          <span style={{ color: "red" }}>{error.email}</span>
                        )}
                      </Form.Group>
                    )}
                    {joinmethod === "phone" && (
                      <Form.Group className="mb-4">
                        <Form.Label
                          className="input_join"
                          htmlFor="inputPassword5"
                        >
                          Phone Number
                        </Form.Label>
                        <PhoneInput
                          className="input_text"
                          inputClass="form-control"
                          type="text"
                          id="inputPassword5"
                          placeholder="Enter your number"
                          aria-describedby="passwordHelpBlock"
                          onChange={handlePhoneNumber}
                          value={dial_code + phoneNo}
                          specialLabel={false}
                          enableSearch={true}
                        />
                        {error && error.phoneNo && (
                          <span style={{ color: "red" }}>{error.phoneNo}</span>
                        )}
                      </Form.Group>
                    )}
                    <Form.Group className="mb-4">
                      <Form.Label
                        className="input_join"
                        htmlFor="inputPassword5"
                      >
                        User Name
                      </Form.Label>
                      <Form.Control
                        className="input_text"
                        type="text"
                        id="inputPassword5"
                        placeholder="Enter your name"
                        aria-describedby="passwordHelpBlock"
                        onChange={handleChange}
                        name="name"
                        value={name}
                      />
                      {error && error.name && (
                        <span style={{ color: "red" }}>{error.name}</span>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label
                        className="input_join"
                        htmlFor="inputPassword5"
                      >
                        Password
                      </Form.Label>
                      <InputGroup className="input_group_box">
                        <Form.Control
                          className=""
                          type={!showPassword ? "password" : "text"}
                          id="inputPassword5"
                          placeholder="Enter your Password"
                          aria-describedby="passwordHelpBlock"
                          name="password"
                          onChange={handleChange}
                          value={password}
                        />
                        {showPassword ? (
                          <InputGroup.Text
                            id="basic-addon1"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            <img
                              src={require("../assets/images/eye_open.png")}
                              alt="img"
                              className="img-fluid "
                              width={20}
                              height={20}
                            />
                          </InputGroup.Text>
                        ) : (
                          <InputGroup.Text
                            id="basic-addon1"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            <img
                              src={require("../assets/images/eye_close.png")}
                              alt="img"
                              className="img-fluid "
                              width={20}
                              height={20}
                            />
                          </InputGroup.Text>
                        )}
                      </InputGroup>
                      {error && error.password && (
                        <span style={{ color: "red" }}>{error.password}</span>
                      )}
                    </Form.Group>
                    <Form.Group className="mb-4">
                      <Form.Label
                        className="input_join"
                        htmlFor="inputPassword5"
                      >
                        Confirm Password
                      </Form.Label>
                      <InputGroup className="input_group_box">
                        <Form.Control
                          className=""
                          type={!showConfirmPassword ? "password" : "text"}
                          id="inputPassword5"
                          placeholder="Enter your Confirm Password"
                          aria-describedby="passwordHelpBlock"
                          name="confirmpassword"
                          onChange={handleChange}
                          value={confirmpassword}
                        />
                        {showConfirmPassword ? (
                          <InputGroup.Text
                            id="basic-addon1"
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                          >
                            <img
                              src={require("../assets/images/eye_open.png")}
                              alt="img"
                              className="img-fluid "
                              width={20}
                              height={20}
                            />
                          </InputGroup.Text>
                        ) : (
                          <InputGroup.Text
                            id="basic-addon1"
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                          >
                            <img
                              src={require("../assets/images/eye_close.png")}
                              alt="img"
                              className="img-fluid "
                              width={20}
                              height={20}
                            />
                          </InputGroup.Text>
                        )}
                      </InputGroup>
                      {error && error.confirmpassword && (
                        <span style={{ color: "red" }}>
                          {error.confirmpassword}
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group className="mb-4">
                      <Form.Label
                        className="input_join"
                        htmlFor="inputPassword5"
                      >
                        Referral Id (Optional)
                      </Form.Label>
                      <Form.Control
                        className="input_text"
                        type="text"
                        id="inputPassword5"
                        placeholder="Enter referral Id"
                        aria-describedby="passwordHelpBlock"
                        value={Id ? Id : referralId}
                        name="referralId"
                        onChange={handleChange}
                      />
                      {/* {error && error.referralId && (
                          <span style={{ color: "red" }}>{error.referralId}</span>
                        )} */}
                    </Form.Group>
                    <Form.Check // prettier-ignore
                      type="checkbox"
                      name="terms"
                      id="custom-switch"
                      label="I Understand Terms of Use and Privacy Policy"
                      className="form_join_check"
                      checked={terms}
                      onChange={handleChange}
                    />
                    {error && error.terms && (
                      <span style={{ color: "red" }}>{error.terms}</span>
                    )}

                    <Button
                      className="nav_btn mx-auto d-block mt-5"
                      onClick={handleClick}
                    >
                      Join {isLoad && <i className="fas fa-spinner fa-spin"></i>}
                    </Button>

                  </div>
                </Col>
                <Col xl="7" className="d-none  d-xl-block">
                  <div className="text-center">
                    <img src={logo} alt="img" className="img-fluid mx-auto " />
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
      ) : (
        <section>
          <Container>
            <div className="join_sec">
              <Row>
                <Col xl="5">
                  <div className="reg_form">
                    <p className="join_head">Register Verify</p>

                    <Form.Group className="mb-4">
                      <Form.Label
                        className="input_join"
                        htmlFor="inputPassword5"
                      >
                        OTP
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          className="input_text"
                          type="text"
                          id="inputPassword5"
                          placeholder="Enter your OTP"
                          aria-describedby="passwordHelpBlock"
                          name="otp"
                          onChange={handleOtpChange}
                          value={numberOnly(otp) ? otp : ""}
                        />
                        <div className="showpass_icon1">
                          {expireTime == 0 ? (
                            <Button
                              className="primary_btn"
                              onClick={
                                joinmethod == "email"
                                  ? resendCode
                                  : resendPhoneCode
                              }
                            >
                              Resend OTP
                            </Button>
                          ) : (
                            <Button className="primary_btn">{`Resend in ${expireTime}`}</Button>
                          )}
                        </div>
                      </InputGroup>
                      {error && error.otp && (
                        <span style={{ color: "red" }}>{error.otp}</span>
                      )}
                    </Form.Group>

                    <Button
                      className="nav_btn mx-auto d-block mt-5"
                      onClick={
                        joinmethod == "email"
                          ? handleOtpClick
                          : handlePhoneOtpClick
                      }
                    >
                      Join {isLoad && <i className="fas fa-spinner fa-spin"></i>}
                    </Button>

                  </div>
                </Col>
                <Col xl="7" className="d-none  d-xl-block">
                  <div className="text-center">
                    <img src={logo} alt="img" className="img-fluid mx-auto " />
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
      )}
      <MyFooter />
    </>
  );
}
